
import Vue from 'vue';
import { settingsHelper } from '@/store/modules/settings';
import { ThemeEnum } from '@/types/theme';
import { supportsCssVars } from '@/util/browser';
// import { setTimeout } from 'timers';
import { delay } from '@/util/helpers';

const settingsHelpers = settingsHelper.mapGetters({ themeStyle: 'themeStyle' });

export default Vue.extend({
  name: 'AppTheme',

  props: {
    theme: { type: String },
  },

  computed: {
    ...settingsHelpers,
    currentTheme(): object {
      return (this as any)[this.theme];
    },
  },
  methods: {
    ...settingsHelper.mapActions({
      setTheme: 'setTheme',
    }),

    async doCssVar() {
      if (supportsCssVars) {
        return;
      }

      let i = 0;
      const max = 100;
      const delayMs = 100;
      while (!(window as any).cssVars && i < 100) {
        ++i;
        await delay(delayMs);
      }

      if ((window as any).cssVars) {
        (window as any).cssVars({
          onlyVars: true,
          variables: this.themeStyle,
          silent: true,
        });
      } else {
        throw new Error('No support for cssVars, cssvars loading took too long.');
      }
    },
    // this is for IE or for browsers that don't support css vars out-of-box
    headDomChanges(e: Event) {
      if (!e.target) {
        return;
      }
      const target = e.target as HTMLStyleElement;
      if (target.type !== 'text/css') {
        return;
      }
      // ponyfill adds with id
      if (target.id) {
        return;
      }

      const doCss = () => this.$doWork('css-var', () => this.doCssVar());

      target.addEventListener('load', doCss, false);
      doCss();

      /* 
      it can take some time for the style to load, 
      this will lead to some dynamic components to not have styles applied, 
      this is not really a good solution, but should be enough,
      the problem I see is some flickering of the layout or this can be quite 
      heavy on low end devices... but this only runs on really outdated browsers
      they should update their browser either way!
      I could implement a better solution for low end devices but that would possible
      harm other parts of the app with this specific logic, that's something I don't
      want to do for legacy systems. - Carlos Rodrigues
      */

      delay(500).then(doCss);
    },
  },

  watch: {
    theme(val) {
      this.setTheme((this as any)[val]);
    },

    themeStyle: {
      handler: 'doCssVar' as any,
      immediate: false,
    },
  },

  beforeMount() {
    // IE support
    if (!supportsCssVars) {
      document.head.addEventListener('DOMNodeInserted', this.headDomChanges, false);
    }
  },
  mounted() {
    this.doCssVar();
  },

  beforeDestroy() {
    if (!supportsCssVars) {
      document.head.removeEventListener('DOMNodeInserted', this.headDomChanges);
    }
  },
});
